export function serializeFormData(obj: { [a: string]: string }) {
    return Object.keys(obj).reduce((a, k) => {
        // tslint:disable-next-line: no-array-mutation
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
    }, [] as string[]).join('&');
}
